export default {
  // Search
  searchPlaceholder: "Search Address/Hash/Survey User ID",
  dataDetails: "Data Details",

  // Page title
  userDetails: "User Details",

  // Buttons
  surveyReport: "Survey Report",
  joinCanvas: "Join Canvas",
  downloadSurveyFile: "Download Survey File",

  // Loading
  loading: "Loading...",

  // Message prompts
  noAddressFound: "No address found",
};
